<template>
	<div id="omapi-section__about-us" class="omapi-section omapi-section__about-us">
		<core-loading v-if="isLoading" />
		<div v-else class="omapi-card__flex">
			<common-card class="omapi-section omapi-section__details">
				<div class="omapi-multi-column omapi-flex omapi-flex-row omapi-flex-row__1080">
					<div class="omapi-multi-column__primary">
						<p class="focus">
							When we started OptinMonster, we had one goal in mind: to help small businesses grow and
							compete with the big guys.
						</p>
						<p>
							We were tired of seeing only the companies with the deepest pockets get access to quality
							lead generation software to grow their list, leads and sales. So we set out to create a
							best-in-class tool at a price even small businesses could afford.
						</p>
						<p>
							Over 1 BILLION people see a website serving OptinMonster campaigns each month. From the
							blogger just getting started or small independent local businesses, to growing eCommerce
							stores and even Fortune 500 companies… we help the most reputable brands online make
							targeted offers to the right person, at the right time.
						</p>
						<p>
							But don’t take our word for it! We have over 240 <span class="stars">★★★★★</span> reviews at
							wordpress.org and almost
							<a
								:href="
									$urls.marketing(
										'testimonials/?utm_source=WordPress&utm_campaign=Plugin&utm_medium=AboutUs'
									)
								"
								target="_blank"
								rel="noopener"
								>100 case studies</a
							>
							from real businesses like yours sharing their real results. We were included in HelpScout's
							2020 Customer Service Awards, nailing a spot in the top 15 amongst all of the thousands of
							B2B companies that use HelpScout to provide support. Our Customer Success team has an
							average time to first response of just over an hour, and an average Happiness rating of 90%.
							Our experienced Customer Success Specialists even offer to build a personalized campaign FOR
							FREE for every OptinMonster customer to get them started on the right foot.
						</p>
						<p>Thank you for the opportunity to help you win and win more often!</p>
					</div>
					<div class="omapi-multi-column__secondary">
						<img src="../../assets/images/om-team.jpg" alt="The OptinMonster Team" />
						<caption>
							The OptinMonster Team
						</caption>
					</div>
				</div>
			</common-card>
			<common-card
				v-for="plugin in plugins"
				:id="plugin.name.toLowerCase().replaceAll(' ', '-')"
				:key="plugin.id"
				size="half"
				content-class="omapi-card__border omapi-plugins"
			>
				<div class="omapi-multi-column omapi-flex omapi-flex-row">
					<div class="omapi-multi-column__secondary omapi-icon-wrapper omapi-icon-wrapper__left">
						<img :src="plugin.icon" :alt="plugin.name" />
					</div>
					<div class="omapi-multi-column__primary">
						<h3 class="omapi-multi-column__title">{{ plugin.name }}</h3>
						<div class="omapi-multi-column__text">{{ plugin.desc }}</div>
					</div>
				</div>
				<template #footer>
					<div class="omapi-status">
						<span class="omapi-multi-column__meta-attr">Status: </span>
						<span
							class="omapi-multi-column__meta-value"
							:class="[
								'Active' === plugin.status ? 'omapi-multi-column__meta-green' : '',
								'Inactive' === plugin.status ? 'omapi-multi-column__meta-red' : '',
							]"
						>
							{{ plugin.status }}
						</span>
					</div>
					<form class="omapi-plugins__form" @submit.prevent="submit(plugin)">
						<!--
						We want the 'rel=friend' attribute so its easiest to have a separate
						link rather than redirecting with window.open
						-->
						<a
							v-if="shouldRedirect(plugin)"
							:href="plugin.url"
							target="_blank"
							rel="friend"
							:class="{
								'button-install': true,
								'omapi-button': true,
								'omapi-button__secondary': true,
								'omapi-button__small': true,
								'omapi-button__blue': true,
							}"
							>Get Plugin</a
						>
						<core-button
							v-else-if="!plugin.installed"
							:disabled="inProgress"
							class="button-install"
							type="secondary"
							color="blue"
							button-type="submit"
							>{{ installButtonText(plugin) }}</core-button
						>
						<core-button
							v-else-if="!plugin.active"
							:disabled="inProgress"
							class="button-activate"
							type="secondary"
							color="blue"
							button-type="submit"
							>{{ activateButtonText(plugin) }}</core-button
						>
					</form>
				</template>
			</common-card>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
	data() {
		return {
			inProgress: false,
		};
	},
	computed: {
		...mapState('plugins', ['plugins']),
		isLoading() {
			return this.$store.getters.isLoading('plugins');
		},
	},
	mounted() {
		this.fetchPlugins();
	},
	methods: {
		...mapActions('plugins', {
			fetchPlugins: 'fetch',
			pluginAction: 'action',
		}),
		shouldRedirect(plugin) {
			return !plugin.installed && 'redirect' === plugin.action;
		},
		installButtonText(plugin) {
			let text = 'Install Plugin';

			if (plugin.id === this.inProgress) {
				text = 'Installing...';
			}

			return text;
		},
		activateButtonText(plugin) {
			let text = 'Activate Plugin';

			if (plugin.id === this.inProgress) {
				text = 'Activating...';
			}

			return text;
		},
		submit(plugin) {
			if (this.inProgress) {
				// We are already working on an install/activation
				return;
			}
			this.inProgress = plugin.id;
			this.pluginAction(plugin)
				.then(() => window.location.reload())
				.catch(() => {
					// There is error handling through the script and API so we don't need to do that here
					this.inProgress = false;
				});
		},
	},
};
</script>
